// extracted by mini-css-extract-plugin
module.exports = {"button":"PrivacyButton_button__1we6Y","focused":"PrivacyButton_focused__3uLtx","unfocused":"PrivacyButton_unfocused__2m4hk"};